import React, { useEffect} from 'react';
import { useDispatch} from 'react-redux';
import {
    btnSearch,
    btnExport 
} from '../../store/precios/reporteseguimientoprecios/actions';

import { Body, Footer, Page } from '@sigeco/tools';

import { Button, Icon, makeStyles } from "@material-ui/core";

import ReporteSeguimientoPreciosList from '../../components/precios/reporteseguimientoprecios/ReporteSeguimientoPrecioList';
import ReporteSeguimientoPreciosFilter from '../../components/precios/reporteseguimientoprecios/ReporteSeguimientoPreciosFilter';

const useStyles = makeStyles(() => ({
    content: {
        padding: '0.5rem 0.75rem 0.75rem'
    },
    root: {
        flex: '0 0 auto',
        marginBottom: '0.75rem',
        '@media (min-width: 1401px)': {
            marginBottom: '1rem',
        }
    }
}));

const ReporteSeguimientoPrecios= ({onClose, setTitle}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    
    useEffect(() => {
        setTitle('Búsqueda');
    // eslint-disable-next-line
    }, []);

    function onBtnClose() {
        onClose();
    }

    return (
        <Page className={classes.root}>
            
            <Body>
                <ReporteSeguimientoPreciosFilter />
                <ReporteSeguimientoPreciosList />
            </Body>

            <Footer>
                <Button
                    color="primary"
                    size="small"
                    variant="outlined"
                    onClick={() => dispatch(btnExport())}
                    startIcon={<Icon className="fas fa-file-excel"/>}
                  >
                    Exportar
                </Button>
              
                <Button
                    color="primary"
                    size="small"
                    variant="outlined"
                    onClick={() => dispatch(btnSearch())}
                    startIcon={<Icon className="fas fa-search"/>}
                >
                    Buscar
                </Button>
                <Button 
                    color="primary" 
                    size="small" 
                    variant="outlined" 
                    onClick={() => onBtnClose()} 
                    startIcon={<Icon className="fas fa-door-open"/>}
                >
                    Salir
                </Button>
            </Footer>
        </Page>
    )
};

export default ReporteSeguimientoPrecios;